module.exports = __webpack_public_path__ + "static/42bd1e59f5b26887ca245bf40b856b14399dd505005b09288a1f5e71a71f8d73-308850bfeebc9359cea43b73395b5e2d.jpeg";